import React, { useRef } from 'react';
import { HiOutlineAcademicCap, HiOutlineX } from 'react-icons/hi';

const INVITATION_COPY = Object.freeze({
    start: {
        title: 'New to creating reports?',
        description: 'Take an optional, step-by-step tutorial through the New Report workflow.',
        action: 'Start tutorial',
    },
    resume: {
        title: 'Continue the report tutorial?',
        description: 'Resume from the workflow step where you paused.',
        action: 'Resume tutorial',
    },
    updated: {
        title: 'Review the report workflow',
        description: 'A newer tutorial is available. Start it when you are ready—nothing will open automatically.',
        action: 'Start tutorial',
    },
});

const HelpInvitation = ({ kind = 'start', onStart, onResume, onPostpone, onDismiss }) => {
    const triggerRef = useRef(null);
    const copy = INVITATION_COPY[kind] || INVITATION_COPY.start;
    const handlePrimaryAction = () => {
        if (kind === 'resume') {
            onResume(triggerRef.current);
        } else {
            onStart(triggerRef.current);
        }
    };

    return (
        <section
            aria-labelledby="help-orientation-invitation-title"
            className="fixed bottom-4 right-4 z-40 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-indigo-200 bg-white p-5 shadow-2xl"
        >
            <div className="flex items-start gap-3">
                <span className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-full bg-indigo-100 text-xl text-indigo-700" aria-hidden="true">
                    <HiOutlineAcademicCap />
                </span>
                <div className="min-w-0 flex-1">
                    <h2 id="help-orientation-invitation-title" className="font-semibold text-text-primary">
                        {copy.title}
                    </h2>
                    <p className="mt-1 text-sm leading-6 text-text-secondary-dark">{copy.description}</p>
                </div>
                <button
                    type="button"
                    onClick={onPostpone}
                    aria-label="Close tutorial invitation"
                    className="inline-flex h-11 w-11 flex-none items-center justify-center rounded-lg text-text-secondary-reg hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                >
                    <HiOutlineX aria-hidden="true" className="text-xl" />
                </button>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2">
                <button
                    ref={triggerRef}
                    type="button"
                    data-help-invitation-primary
                    onClick={handlePrimaryAction}
                    className="inline-flex min-h-11 items-center justify-center rounded-lg bg-normative-blue px-4 py-2 font-semibold text-white hover:bg-indigo-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                >
                    {copy.action}
                </button>
                <button
                    type="button"
                    onClick={onPostpone}
                    className="inline-flex min-h-11 items-center justify-center rounded-lg px-3 py-2 text-sm font-medium text-text-secondary-dark hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                >
                    Not now
                </button>
                <button
                    type="button"
                    onClick={onDismiss}
                    className="inline-flex min-h-11 items-center justify-center rounded-lg px-3 py-2 text-sm font-medium text-text-secondary-reg hover:bg-red-50 hover:text-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                >
                    Don’t show again
                </button>
            </div>
        </section>
    );
};

export default HelpInvitation;
